import React, { useEffect, useRef } from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import { makeStyles, Box } from "@material-ui/core";
import useCompanyTitle from "../../../hooks/useCompanyTitle.js";
import LevelHeader from "./components/LevelHeader.jsx";
import BranchList from "./BranchList.jsx";
import DeckList from "./DeckList.jsx";
import MyScrollbars from "../../../SharedComponents/MyScrollbars.jsx";
import { useBaseData } from "../../../Providers/Data/BaseDataProvider.jsx";
import EmptyLevelsMessage from "./components/EmptyLevelsMessage.jsx";

const useStyles = makeStyles(() => ({
  courseStatPageRoot: {
    padding: "16px 22px",
    "& .MuiDivider-root": {
      margin: "20px 0",
    },
  },
}));

/** */
const BranchDeckLayout = () => {
  const classes = useStyles();
  useCompanyTitle("title.home");
  const location = useLocation();
  const { levelsAndReward } = useBaseData();
  const osRef = useRef(/** @type {?OverlayScrollbarsComponent} */ null);

  // автоскрол при переключении
  useEffect(() => {
    const osInstance = osRef.current && osRef.current.osInstance();
    if (osInstance) {
      osInstance.scroll(scrollTo, 200);
    }
  }, [location.pathname]);

  return (
    <MyScrollbars ref={osRef}>
      <Box className={classes.courseStatPageRoot}>
        {levelsAndReward?.levels?.length === 0 ? (
          <EmptyLevelsMessage />
        ) : (
          <>
            <LevelHeader />
            <Switch>
              <Route exact path="/branches">
                <BranchList />
              </Route>
              <Route exact path="/decks">
                <DeckList />
              </Route>
            </Switch>
          </>
        )}
      </Box>
    </MyScrollbars>
  );
};

export default BranchDeckLayout;
